// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:31:56

export default {
  "id": "black-hole-beauty-makeup",
  "slug": "black-hole-beauty-makeup",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/60832a32b0c44409961bc98128b9cbbd-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/60832a32b0c44409961bc98128b9cbbd/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Black Hole: Beauty Makeup",
      "description": "Black Hole: Beauty Makeup is a game where the player controls a black hole trying to devour as many objects around it as possible. Eat more, grow more, then create a beauty makeover!  Cool black hole simulator. Absorb different objects. Unlock skins. Do you like black hole and simulators?",
      "instructions": "The player controls the black hole by moving it around the screen and trying to absorb as many objects as possible. \nThe more objects the player absorbs, the more points he gets.",
      "genres": [
        "Casual"
      ],
      "tags": [
        "destroy",
        "fashion",
        "hole",
        "makeup",
        "skin"
      ]
    },
    "zh-CN": {
      "title": "黑洞：美丽妆容",
      "description": "黑洞：美丽化妆是一款玩家控制黑洞，试图吞噬尽可能多的周围物体的游戏。吃得越多，长得越大，然后进行美丽变身！酷炫的黑洞模拟器。吸收不同物体。解锁皮肤。你喜欢黑洞和模拟器吗？",
      "instructions": "玩家控制黑洞在屏幕上移动，并尝试吸收尽可能多的物体。\n玩家吸收的物体越多，得到的分数就越高。",
      "genres": [
        "休闲"
      ],
      "tags": [
        "摧毁",
        "时尚",
        "洞",
        "化妆",
        "皮肤"
      ]
    },
    "zh-TW": {
      "title": "黑洞：美妝之美",
      "description": "黑洞：美妝遊戲是一款玩家控制一個黑洞，試圖吞噬周圍盡可能多的物體的遊戲。吃得越多，長得越大，然後創造美妝變身！酷炫的黑洞模擬器。吸收不同的物體。解鎖外觀。你喜歡黑洞和模擬器嗎？",
      "instructions": "玩家透過移動黑洞在螢幕上，試圖吸收盡可能多的物體。\n玩家吸收的物體越多，得分也越高。",
      "genres": [
        "休闲"
      ],
      "tags": [
        "毀損",
        "時尚",
        "洞",
        "妝容",
        "皮膚"
      ]
    },
    "zh-HK": {
      "title": "黑洞：美妝",
      "description": "黑洞：美妝是一款玩家操控黑洞，試圖吞噬周圍盡可能多的物體的遊戲。吃得越多，就會越來越大，然後就能進行美妝改造！酷炫的黑洞模擬器。吸收不同的物體。解鎖外觀。你喜歡黑洞和模擬器嗎？",
      "instructions": "玩家透過移動黑洞在螢幕上，並嘗試吸收盡可能多的物件。\n玩家吸收的物件越多，得分也越高。",
      "genres": [
        "隨意"
      ],
      "tags": [
        "摧毀",
        "時尚",
        "洞",
        "妝容",
        "肌膚"
      ]
    },
    "ja": {
      "title": "ブラックホール：ビューティーメイクアップ",
      "description": "ブラックホール：ビューティーメイクアップは、プレイヤーがブラックホールを操作し、周囲の物体をできるだけ多く捕食するゲームです。もっと食べることで大きくなり、その後ビューティーメイクアップを作成します！クールなブラックホールシミュレータ。異なる物体を吸収します。スキンを解除します。ブラックホールとシミュレータが好きですか？",
      "instructions": "プレイヤーはブラックホールを画面内で動かし、できるだけ多くの物体を吸収しようとします。プレイヤーが吸収する物体が増えると、得点も増えます。",
      "genres": [
        "カジュアル"
      ],
      "tags": [
        "破壊",
        "ファッション",
        "穴",
        "メイクアップ",
        "肌"
      ]
    },
    "ko": {
      "title": "블랙홀: 미용 뷰티 메이크업",
      "description": "블랙홀: 미용 메이크업은 플레이어가 블랙홀을 조종하여 주변의 가능한 많은 물체를 삼키려는 게임입니다. 더 많이 먹으면 더 커지고, 그런 다음 미용 메이크업을 만들어보세요! 쿨한 블랙홀 시뮬레이터. 다양한 물체를 흡수합니다. 스킨을 해금합니다. 블랙홀과 시뮬레이터를 좋아하세요?",
      "instructions": "플레이어는 화면을 돌아다니며 블랙홀을 이동시키고 가능한 많은 물체를 흡수하려고 합니다. 플레이어가 흡수하는 물체가 많을수록 점수가 더 많이 얻습니다.",
      "genres": [
        "캐주얼"
      ],
      "tags": [
        "파괴",
        "패션",
        "구멍",
        "메이크업",
        "피부"
      ]
    },
    "fr": {
      "title": "Trou noir : Beauté Maquillage",
      "description": "Noir Noir : Beauté Maquillage est un jeu où le joueur contrôle un trou noir essayant de dévorer le plus d'objets autour de lui possible. Mange plus, grandis plus, puis crée une transformation de beauté ! Cool simulateur de trou noir. Absorbe différents objets. Débloque des skins. Aimerez-vous le trou noir et les simulateurs ?",
      "instructions": "Le joueur contrôle le trou noir en le déplaçant sur l'écran et en essayant d'absorber le plus d'objets possible.\nPlus d'objets le joueur absorbe, plus il gagne de points.",
      "genres": [
        "Casual"
      ],
      "tags": [
        "détruire",
        "mode",
        "trou",
        "maquillage",
        "peau"
      ]
    }
  }
};
